import { ArpMedia, ArpMediaType, User } from '@arpeggi/shared'
import { useMemo, useState } from 'react'
import { useImmer } from 'use-immer'
import { IArpMedia } from '../../features/arp-registry/ArpMedia'
import ArpRegistry from '../../features/arp-registry/ArpRegistry'
import { getArpMedia } from '../../__legacy__/api/v2/ArpMediaAPI'
import { useAsyncEffect } from '../components/platform/explore/common/utils'

const useFeaturedMediaDrawerData = () => {
  const [songsLoaded, setSongsLoaded] = useState<boolean>(false)
  const [samplesLoaded, setSamplesLoaded] = useState<boolean>(false)
  const [songData, setSongData] = useState<ArpMedia[]>([])
  const [artistProfiles, setArtistProfiles] = useImmer<{ [key: string]: User }>({})
  const [samplesByArtist, setSamplesByArtist] = useImmer({})

  useAsyncEffect(async () => {
    if (!ArpRegistry.readyForStudioUse) {
      return
    }

    setSongsLoaded(false)
    const { data: featuredMedia } = await getArpMedia({ parts: ['subComponents'], featured: true })

    const arpSamples = featuredMedia.filter((x) => x.type === ArpMediaType.SAMPLE)

    ArpRegistry.getByIdsAsync(arpSamples.map((sample) => sample.id)).then(
      (samples: IArpMedia[]) => {
        setSamplesLoaded(true)
        samples.forEach(({ id, user: { walletAddress } }) => {
          setSamplesByArtist((draft) => {
            draft[walletAddress] = draft[walletAddress] ? [...draft[walletAddress], id] : [id]
          })

          setArtistProfiles((draft) => {
            draft[walletAddress] = arpSamples.find(
              (x) => x.user.walletAddress === walletAddress
            ).user
          })
        })
      }
    )

    const songs = featuredMedia.filter((x) => x.type === ArpMediaType.SONG)

    setSongData(songs)
    setSongsLoaded(true)

    songs.forEach(({ user }) => {
      setArtistProfiles((draft) => {
        draft[user.walletAddress] = user
      })
    })
  }, [ArpRegistry.readyForStudioUse])

  const processedSongs: IArpMedia[] = useMemo(() => ArpRegistry.setMedias(songData), [songData])

  return { songsLoaded, samplesLoaded, songData: processedSongs, artistProfiles, samplesByArtist }
}

export default useFeaturedMediaDrawerData
